import AV from 'leancloud-storage'

export const XTTrack = AV.Object.extend('XtTrack')

// 暂时未使用
XTTrack.getXTTracksByXMIds = function (xmIds, page = 1, perPage = 15) {
  return AV.Cloud.rpc('getXTTracksByXMIds', {
    xmIds,
    page,
    perPage
  })
}

// 获取专辑下的声音
XTTrack.getXTTracksByAlbum = function (albumId, page = 1, perPage = 15) {
  return AV.Cloud.rpc('getXTTracksByAlbum', {
    albumId,
    page,
    perPage
  })
}



// WEBPACK FOOTER //
// ./src/models/xct_track.js